import React, { FC, PropsWithChildren } from 'react'

import { Tooltip } from 'components/block/PhotoLine/PhotoLineTooltip.styled'
import { VipGiftTooltipContainer } from 'components/page/ForeignProfile/Gifts/Gifts.styled'
import { tooltipGiftWidth } from 'components/page/UserProfile/constants'
import { CenterTooltip } from 'components/presentational/Tooltip'

export const PresenterVipDescriptionContainer: FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <VipGiftTooltipContainer>
      <CenterTooltip>
        <Tooltip style={{ width: `${tooltipGiftWidth}px` }}>{children}</Tooltip>
      </CenterTooltip>
    </VipGiftTooltipContainer>
  )
}
